module.exports = __webpack_public_path__ + "img/Grupo 8.6e12828a.svg";